import { CommonModule } from '@angular/common'
import {
  Component,
  Input,
  Output,
  EventEmitter,
  inject,
  computed,
} from '@angular/core'

import { Enums } from '@cyborg-monorepo/hunter/common'
import { TypographyComponent } from '@hyperkit'
import {
  IconTypes,
  IconValuesType,
} from 'pkgs/hyperkit/src/components/icon/icon.component.types'

import { SessionService } from '@hunt/services'

export interface Section {
  id: string
  title: string
  status?: Enums.StatusEnum
  children?: Section[]
}

@Component({
  standalone: true,
  imports: [CommonModule, TypographyComponent],
  selector: 'hyperkit-report-section',
  templateUrl: './report-section.component.html',
  styleUrls: ['./report-section.component.scss'],
})
export class ReportSectionComponent {
  readonly session = inject(SessionService)
  readonly loaded = computed(
    () => !this.session.loading() && this.session.activeHunt() !== null,
  )
  @Input() section: Section
  @Input() selectedSectionId: string
  @Output() selectSection = new EventEmitter<string>()

  isSelected(section: Section): boolean {
    return section.id === this.selectedSectionId
  }

  getStatusIcon(status?: Enums.StatusEnum): IconValuesType {
    switch (status) {
      case Enums.StatusEnum.TO_DO:
        return IconTypes.Circle // Could be replaced with actual icon component
      case Enums.StatusEnum.IN_PROGRESS:
        return IconTypes.Loader // Could be replaced with actual icon component
      case Enums.StatusEnum.DONE:
        return IconTypes.CheckCircle // Could be replaced with actual icon component
    }
  }

  onSectionClick(sectionId: string): void {
    this.selectSection.emit(sectionId)
  }
}
